import React, { useEffect } from 'react';
import Header from '../Components/ExhibitorPortalEvent/Header';
import Footer from '../Components/ExhibitorPortalEvent/Footer';
import {Outlet,useNavigate} from 'react-router-dom';
import { useSelector} from 'react-redux';

function EPortalEventLayout (props){
  const navigation = useNavigate();
  const apiToken = useSelector(store => store.user['token'])
  const loggedUser = useSelector(store => store.user['user'])

  useEffect(() => {
    if(!apiToken){
      navigation('/login');
    }/* else {
      if(loggedUser.user_role==2)
      {
        navigation("/Exhibitorhome");
      } else if(loggedUser.user_role==1)
      {
        navigation("/");
      }
    }*/
  },[apiToken]);
  return (
  <>
    <Header/>
      <main style={{ padding: '1rem 0' }}>
        <Outlet />
      </main>
    <Footer/>
  </>)
};

export default EPortalEventLayout;